'use client'

import {
  FiltersContext,
  FiltersDispatchContext,
  SealedParamsContext
} from '@/modules/accredited-establishments/contexts'
import { useFiltersReducer } from '../hooks'
import { PropsWithChildren, useRef } from 'react'

type FiltersContextProviderProps = PropsWithChildren<{
  initialParams?: Record<string, string>
}>

const FiltersContextProvider = ({
  initialParams = {},
  children
}: FiltersContextProviderProps) => {
  const { filters, filtersDispatch } = useFiltersReducer()
  const paramsRef = useRef(initialParams)
  const latestRequestIdRef = useRef(0)

  return (
    <SealedParamsContext.Provider value={{ paramsRef, latestRequestIdRef }}>
      <FiltersDispatchContext.Provider value={filtersDispatch}>
        <FiltersContext.Provider value={filters}>
          {children}
        </FiltersContext.Provider>
      </FiltersDispatchContext.Provider>
    </SealedParamsContext.Provider>
  )
}

export { FiltersContextProvider }
